import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['checkbox', 'form']

  toggleAll(event) {
    const selectAllCheckbox = event.target
    const isChecked = selectAllCheckbox.checked

    this.checkboxTargets.forEach((checkbox) => {
      checkbox.checked = isChecked
    })
  }

}
